import api from '@pray/shared/utils/api';

export const getAllLeadClients = async ({
  offset = 0,
  limit = 0,
  sortColumn = '',
  sortDirection = 'asc',
  search = '',
  artistId = '',
  scope = '',
  options = {},
} = {}) => {
  const params = {};

  if (offset) params.offset = offset;

  if (limit) params.limit = limit;

  if (sortColumn) {
    params.sort_column = sortColumn;
    params.sort_direction = sortDirection;
  }

  if (search) params.search = search;

  if (artistId) params.artist_id = artistId;

  // Omitted means lead scope: the endpoint defaults that way so every caller that predates
  // subscriber integrations keeps listing destinations for leads. Pass 'all' to manage both.
  if (scope) params.scope = scope;

  const url = `/web/studio/lead-clients`;
  const response = await api.executeGetRequest(url, params, options);

  return response.data;
};
